<div class="grid" [formGroup]="form">
	<div class="col-12">
		<div class="card">
			<h5>Enviar notificaciones</h5>
			<div class="col-12 md:col-12">
				<div class="field col-12">
					<label for="name">*Título</label>
					<input
						id="name"
						type="text"
						formControlName="title"
						maxlength="50"
						pInputText
						class="w-full mb-3"
					/>
				</div>

				<div class="field col-12">
					<label for="name">*Contenido</label>
					<textarea
						class="w-full mb-3"
						id="name"
						formControlName="content"
						maxlength="255"
						minlength="3"
						pInputTextarea
					></textarea>
				</div>
			</div>

			<div class="col-12 md:col-12">
				<p-tabView [(activeIndex)]="active">
					<p-tabPanel header="Enviar a">
						<div class="mb-4">
							<span
								>Elije el grupo de usuarios a los que deseas enviar la
								notificación:</span
							>
						</div>
						<div>
							<div class="field-checkbox">
								<p-radioButton
									inputId="todos"
									[value]="0"
									formControlName="type"
									(ngModelChange)="handleView($event)"
								></p-radioButton>
								<label for="todos">Todos</label>
							</div>
							<div *ngFor="let userType of typeUsers" class="field-checkbox">
								<p-radioButton
									[inputId]="userType.key"
									[value]="userType.value"
									formControlName="type"
									(ngModelChange)="handleView($event)"
								></p-radioButton>
								<label [for]="userType.key">{{ userType.label }}</label>
							</div>
						</div>
						<b class=""
							>¡Importante!: se envía una notificación, según el grupo
							seleccionado, a todos los usuarios con la app descargada.</b
						>
						@if(customers1.length > 0){
						<p-table
							[value]="customers1"
							styleClass="mt-5"
							dataKey="email"
							[rows]="5"
							[paginator]="true"
							[tableStyle]="{ width: '100%' }"
							responsiveLayout="stack"
							[breakpoint]="'960px'"
						>
							<ng-template pTemplate="header">
								<tr [pSelectableRow]="user">
									<th>Nombre</th>
									<th>Correo electrónico</th>
								</tr>
							</ng-template>
							<ng-template
								pTemplate="body"
								let-user
								let-columns="columns"
								let-rowIndex="rowIndex"
							>
								<tr [pSelectableRow]="user" [pSelectableRowIndex]="rowIndex">
									<td>
										<span class="p-column-title font-bold">Nombre:</span
										>{{ user.name }}
									</td>
									<td>
										<span class="p-column-title font-bold">Correo:</span
										>{{ user.email }}
									</td>
								</tr>
							</ng-template>
						</p-table>
						}
					</p-tabPanel>
				</p-tabView>
			</div>

			<div class="flex justify-content-end mt-3 w-full">
				<button
					pButton
					class="p-button-rounded"
					[disabled]="form.invalid || loading"
					(click)="sendNotification()"
					label="Enviar"
					icon="pi pi-send"
					iconPos="right"
				></button>
			</div>
		</div>
	</div>
</div>
